var _defs, _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgGradient(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 320 199",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: url(#Degradado_sin_nombre_502);\n        opacity: .76;\n      }\n\n      .cls-1, .cls-2, .cls-3 {\n        mix-blend-mode: color-dodge;\n        stroke-width: 0px;\n      }\n\n      .cls-2 {\n        fill: url(#Degradado_sin_nombre_502-3);\n      }\n\n      .cls-2, .cls-3 {\n        opacity: .78;\n      }\n\n      .cls-3 {\n        fill: url(#Degradado_sin_nombre_502-2);\n      }\n\n      .cls-4 {\n        isolation: isolate;\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_502",
    "data-name": "Degradado sin nombre 502",
    x1: 319.47,
    y1: -328.34,
    x2: 235.34,
    y2: 160.68,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_502-2",
    "data-name": "Degradado sin nombre 502",
    x1: 251.84,
    y1: -339.97,
    x2: 167.7,
    y2: 149.04,
    xlinkHref: "#Degradado_sin_nombre_502"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_502-3",
    "data-name": "Degradado sin nombre 502",
    x1: 231.77,
    y1: -343.43,
    x2: 147.64,
    y2: 145.59,
    xlinkHref: "#Degradado_sin_nombre_502"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Capa_1",
    "data-name": "Capa 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m319.01,204.42c8.28,0,14.99-6.71,14.99-14.99V11.6c0-8.28-6.71-14.99-14.99-14.99h-49.78L123.98,204.42h195.03Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "111.51 204.42 256.76 -3.39 240.6 -3.39 95.34 204.42 111.51 204.42"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "85.56 204.42 230.81 -3.39 225.23 -3.39 79.98 204.42 85.56 204.42"
  }))))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGradient);
export default __webpack_public_path__ + "static/media/gradient.72560bb93b13c50ceda3863ca8e6001a.svg";
export { ForwardRef as ReactComponent };